// extracted by mini-css-extract-plugin
module.exports = {"panelList":"PanelList_panelList__198h2"};